import React from 'react'
import { Card, Drawer, Form, Icon, Select, notification, Button, Tooltip, Input, Row, Col, DatePicker } from 'antd'
import { TableComp, FormUtils as GetAllFormFields, query } from 'sz-react-utils'
import _ from 'lodash'
import { connect } from 'react-redux'
import TextArea from 'antd/lib/input/TextArea'
import Request, { API_URL } from '../../request'
import AddTask from './AddTask'
import TaskViewer from './TaskViewer'

import { formatDate } from '@fullcalendar/core'
import FullCalendar from '@fullcalendar/react'
import dayGridPlugin from '@fullcalendar/daygrid'
import timeGridPlugin from '@fullcalendar/timegrid'
import interactionPlugin from '@fullcalendar/interaction'
import moment from 'moment'

const dateFormat = localStorage.getItem('companyDetails') ? JSON.parse(localStorage.getItem('company-details')).dateFormat : 'DD.MM.YYYY';
const { RangePicker } = DatePicker;
const Option = Select.Option

let colorMaping = {
    High: '#eb354b',
    Low: '#6495ED',
    Normal: '#50C878'
}

let statusMaping = {
    Pending: '#dc143c', //red
    Complete: '#5C9377', //green
    Forward: '#4169E1' //blue
}

@Form.create()

class TaskList extends React.Component {
    state = {
        visible: true,
        withdrawReason: '',
        withdrawDate: '',
        showAddTaskForm: false,
        showTaskListForm: false,
        allUsers: [],
        weekendsVisible: true,
        currentEvents: [],
        allEvents: [],
        startDate: '',
        endDate: '',
        filterStatus: 'Pending',
        filterPriority: '',
        assignById: '',
        assignId: '',
        counsellors: [],
        time: {
            // from:moment().startOf('month'),
            // to:moment().endOf('month')
        }
    }

    closeDocument = () => {
        this.setState({
            showAddTaskForm: false,
            showTaskListForm: false
        })
        this.refreshTasks()
    }

    refreshTasks = () => {
        this.table.current.reload()
        setTimeout(() => {
            this.getCalendarData({
                startStr: this.state.startDate,
                endStr: this.state.endDate
            })
        }, 400)
    }

    async componentDidMount() {
        let localUser = JSON.parse(localStorage.getItem("user"));
        let { data: allUsers } = await Request.loadDeskUser({
            results: 10000,
            active: true,
            userId: localUser._id,
        });
        this.setState({ allUsers });
    }

    handleDateSelect = (selectInfo) => {
        if (moment().isAfter(selectInfo.startStr, 'date')) {
            return notification.error({
                message: `You can't add task before today's Date`
            })
        }
        this.setState({ showAddTaskForm: true, taskDate: selectInfo.startStr });
    }

    handleEventClick = (clickInfo) => {
        this.setState({ showTaskListForm: true, taskId: clickInfo.event._def.publicId });
    }

    showTaskDetails = (record) => {
        this.setState({ showTaskListForm: true, taskId: record._id });
    }

    handleEvents = (events) => {
        this.setState({
            currentEvents: events
        })
    }
    getCalendarData = async (dates) => {
        let startDate = (dates.startStr)
        let endDate = (dates.endStr)

        this.setState({ startDate, endDate })
        let params = {};

        params.dueDate = {
            $gte: startDate,
            $lte: endDate
        };
        if (this.state.filterStatus) {
            params.status = this.state.filterStatus
        }
        if (this.state.filterPriority) {
            params.priority = this.state.filterPriority
        }
        if (this.state.assignById) {
            params.assignById = this.state.assignById
        }
        if (this.state.assignId) {
            params.assignId = this.state.assignId
        }
        let response = await Request.getAllTaskListAssignToUser(params);

        let events = [];
        _.each(response.data, (event) => {
            const startDateTime = moment(event.startDate).format('YYYY-MM-DD') + ' ' + event.startTime
            events.push({
                id: event._id,
                title: event.taskTitle,
                priority: event.priority,
                status: event.status,
                start: (event.startDate ? startDateTime : event.dueDate)
            })
        })
        this.setState({ allEvents: events });
    }

    eventAddHandler = async (event) => {
    }

    constructor(props) {
        super(props)
        this.table = React.createRef();
    }

    chooseRangerPicker = (date, dateString) => {
        this.setState(
            {
                time: {
                    from: date[0],
                    to: date[1],
                },
            },
            () => {
                this.reload();
            }
        );
        if (date[0] === undefined) {
            setTimeout(() => {
                this.reload();
            }, 500);
        }
    };

    onOk = value => {
        this.reload()
    }
    reload = () => {
        this.table.current.reload();
    };

    apiRequest = (params) => {
        return new Promise(async (resolve) => {

            let startDate = this.state.time.from;
            let endDate = this.state.time.to;

            this.setState({ startDate, endDate })
            if (!params) {
                let params = {};
            }

            if (this.state.filterStatus) {
                params.status = this.state.filterStatus
            }
            if (this.state.filterPriority) {
                params.priority = this.state.filterPriority
            }
            if (this.state.assignById) {
                params.assignById = this.state.assignById
            }
            if (this.state.assignId) {
                params.assignId = this.state.assignId
            }
            params.time = this.state.time;
            // params["createdByUser.time"] = {
            //     $gte:this.state.time.from,
            //     $lte:this.state.time.to
            // }
            let taskResponse = await Request.getAllTasksList(params);
            let events = [];
            _.each(taskResponse.data, (event) => {
                const startDateTime = moment(event.startDate).format('YYYY-MM-DD') + ' ' + event.startTime
                events.push({
                    id: event._id,
                    title: event.taskTitle,
                    priority: event.priority,
                    status: event.status,
                    start: (event.startDate ? startDateTime : event.dueDate)
                })
            })
            this.setState({ allEvents: events });
            resolve(taskResponse)
        })
    }


    renderEventContent = (eventInfo) => {
        let priority = eventInfo.event.extendedProps.priority;
        let status = eventInfo.event.extendedProps.status;
        let backgroundColorMap = statusMaping[status];
        let priorityColorMap = colorMaping[priority];
        return (
            <div title={eventInfo.event.title} style={{ backgroundColor: backgroundColorMap, padding: '2px', color: 'white' }}>
                <i style={{ backgroundColor: priorityColorMap }}>{priority}</i>&nbsp; | &nbsp;<i>{eventInfo.event.title.substring(0, 15)}</i>
            </div>
        )
    }

    render() {
        const {
            form: { getFieldDecorator, setFieldsValue }
        } = this.props
        const { allUsers, taskId, allEvents, taskDate, showAddTaskForm, showTaskListForm } = this.state;
        // let columns = [
        //     {
        //         title: 'Sr No.',
        //         key: 'serialNumber',
        //         width: 50,
        //         render: (text, record, index) => (
        //             <span>{index + 1}</span>
        //         )
        //     },
        //     {
        //         title: 'Task',
        //         key: 'taskTitle',
        //         width:380,
        //         searchTextName: 'Task Title',
        //         filterRegex: true,
        //         render:(text,record)=>(
        //             <div>
        //                 <p>{record.taskTitle}</p>
        //                 <small>By:- {record.assignById.name}</small>
        //             </div>
        //         )
        //     },
        //     {
        //         title:'Assigned To',
        //         key:'assignId.name',
        //         width:90,
        //     },
        //     {
        //         title: 'Added Date',
        //         key: 'createdByUser.time',
        //         width:80,
        //         render: (text, record) => (
        //             record.createdByUser ? moment(record.createdByUser.time).format(dateFormat) : "N/A"
        //         )
        //     },
        //     {
        //         title: 'Due Date',
        //         key: 'dueDate',
        //         width:80,
        //         render: (text, record) => (
        //             <span>{moment(text).format(dateFormat)}</span>
        //         )
        //     },
        //     {
        //         title: 'Priority',
        //         key: 'priority',
        //         width:80,
        //         render: (text, record) => {
        //             if (text === "High") {
        //                 return (
        //                     <span style={{ backgroundColor: '#eb354b', color: '#fff', padding: 5 }}>{text}</span>
        //                 )
        //             } else if (text === "Normal") {
        //                 return (
        //                     <span style={{ backgroundColor: '#50C878', color: '#fff', padding: 5 }}>{text}</span>
        //                 )
        //             } else {
        //                 return (
        //                     <span style={{ backgroundColor: '#6495ED', color: '#fff', padding: 5 }}>{text}</span>
        //                 )
        //             }
        //         }
        //     },
        //     {
        //         title: 'Status',
        //         key: 'status',
        //         width:80,
        //         render: (text, record) => {
        //             if (text === "Pending") {
        //                 return (
        //                     <span style={{ backgroundColor: '#dc143c', color: '#fff', padding: 5 }}>{text}</span>
        //                 )
        //             } else if (text === "Complete") {
        //                 return (
        //                     <span style={{ backgroundColor: '#5C9377', color: '#fff', padding: 5 }}>{text}</span>
        //                 )
        //             } else if (text === "Forward") {
        //                 return (
        //                     <span style={{ backgroundColor: '#4169E1', color: '#fff', padding: 5 }}>{text}</span>
        //                 )
        //             }
        //         }
        //     },
        //     {
        //         title: 'View',
        //         key: 'viewDetails',
        //         width:50,
        //         render: (text, record) => (
        //             <Button type="primary" icon='eye' onClick={() => this.showTaskDetails(record)}></Button>
        //         )
        //     },
        // ]
        let columns = [
            {
                title: 'Sr No.',
                key: 'serialNumber',
                width: 60,
                align: 'center',
                render: (text, record, index) => (
                    <span style={{ color: '#8c8c8c', fontWeight: 500 }}>{index + 1}</span>
                )
            },
            {
                title: 'Task Details',
                key: 'taskTitle',
                width: 380,
                searchTextName: 'Task Title',
                filterRegex: true,
                render: (text, record) => {
                    // Manual check for nested assignById
                    const assignedByName = (record.assignById && record.assignById.name)
                        ? record.assignById.name
                        : 'N/A';

                    return (
                        <div style={{ padding: '4px 0' }}>
                            <div style={{ fontWeight: 600, color: '#262626', fontSize: '14px', marginBottom: '2px' }}>
                                {record.taskTitle}
                            </div>
                            <div style={{ fontSize: '12px', color: '#8c8c8c' }}>
                                <span style={{ fontStyle: 'italic' }}>Assigned by:</span> {assignedByName}
                            </div>
                        </div>
                    );
                }
            },
            {
                title: 'Assigned To',
                key: 'assignId.name',
                width: 140,
                render: (text, record) => {
                    // Manual check for nested assignId
                    const assigneeName = (record.assignId && record.assignId.name)
                        ? record.assignId.name
                        : 'Unassigned';
                    const initial = assigneeName.charAt(0).toUpperCase();

                    return (
                        <div style={{ display: 'flex', alignItems: 'center' }}>
                            <div style={{
                                width: 26, height: 26, borderRadius: '50%', backgroundColor: '#f5f5f5',
                                display: 'flex', justifyContent: 'center', alignItems: 'center',
                                marginRight: 10, fontSize: 11, border: '1px solid #d9d9d9', color: '#595959'
                            }}>
                                {initial}
                            </div>
                            <span style={{ fontWeight: 500, color: '#434343' }}>{assigneeName}</span>
                        </div>
                    );
                }
            },
            {
                title: 'Timeline',
                key: 'dates',
                width: 150,
                render: (text, record) => {
                    const isOverdue = moment(record.dueDate).isBefore(moment()) && record.status !== 'Complete';
                    return (
                        <div style={{ fontSize: '12px', lineHeight: '1.6' }}>
                            <div style={{ color: '#8c8c8c' }}>
                                Added: {record.createdByUser ? moment(record.createdByUser.time).format('DD MMM') : "N/A"}
                            </div>
                            <div style={{
                                color: isOverdue ? '#f5222d' : '#595959',
                                fontWeight: isOverdue ? 600 : 500
                            }}>
                                Due: {moment(record.dueDate).format('DD MMM, YYYY')}
                            </div>
                        </div>
                    );
                }
            },
            {
                title: 'Priority',
                key: 'priority',
                width: 100,
                align: 'center',
                render: (text) => {
                    const priorityMap = {
                        High: { color: '#fff1f0', border: '#ffa39e', text: '#cf1322' },
                        Normal: { color: '#f6ffed', border: '#b7eb8f', text: '#389e0d' },
                        Low: { color: '#e6f7ff', border: '#91d5ff', text: '#096dd9' }
                    };
                    const style = priorityMap[text] || priorityMap.Low;
                    return (
                        <span style={{
                            backgroundColor: style.color,
                            color: style.text,
                            border: `1px solid ${style.border}`,
                            padding: '2px 10px',
                            borderRadius: '12px',
                            fontSize: '11px',
                            fontWeight: 600,
                            display: 'inline-block',
                            minWidth: '65px'
                        }}>
                            {text}
                        </span>
                    );
                }
            },
            {
                title: 'Status',
                key: 'status',
                width: 110,
                align: 'center',
                render: (text) => {
                    const statusMap = {
                        Pending: { bg: '#fff7e6', dot: '#fa8c16', color: '#d46b08' },
                        Complete: { bg: '#f6ffed', dot: '#52c41a', color: '#389e0d' },
                        Forward: { bg: '#f0f5ff', dot: '#2f54eb', color: '#1d39c4' }
                    };
                    const s = statusMap[text] || statusMap.Pending;
                    return (
                        <span style={{
                            display: 'inline-flex',
                            alignItems: 'center',
                            backgroundColor: s.bg,
                            color: s.color,
                            padding: '3px 12px 3px 8px',
                            borderRadius: '4px',
                            fontSize: '12px',
                            fontWeight: 600,
                            border: `0.5px solid ${s.dot}33` // Subtle transparency border
                        }}>
                            <span style={{
                                width: 6, height: 6, borderRadius: '50%',
                                backgroundColor: s.dot, marginRight: 8
                            }} />
                            {text}
                        </span>
                    );
                }
            },
            {
                title: 'View',
                key: 'viewDetails',
                width: 60,
                align: 'center',
                render: (text, record) => (
                    <Button
                        type="primary"
                        ghost
                        shape="circle"
                        icon='eye'
                        onClick={() => this.showTaskDetails(record)}
                        style={{ fontSize: '16px' }}
                    />
                )
            },
        ];
        return (
            <div>
                {
                    showAddTaskForm ?
                        <AddTask taskDate={taskDate} allUsers={allUsers} onClose={this.closeDocument} />
                        : null
                }
                {
                    showTaskListForm ?
                        <TaskViewer className="task-viewer" allUsers={allUsers} taskId={taskId} onClose={this.closeDocument} />
                        : null
                }
                <Card bordered={true}>
                    <Row style={{ marginBottom: '2rem' }}>
                        <Col span={2} style={{}}>
                            <Button type='primary' onClick={() => {
                                this.setState({ showAddTaskForm: true })
                            }}>Add New Task</Button>
                        </Col>
                    </Row>
                    <Row style={{ marginBottom: '2rem' }}>
                        <Col span={6}>
                            Assign To
                            <br></br>
                            <div style={{ float: 'left', width: '100%' }}>
                                <Select
                                    allowClear
                                    style={{
                                        width: '90%'

                                    }}
                                    showSearch={true}
                                    value={this.state.assignId}
                                    placeholder="Select Option"
                                    optionFilterProp="display"
                                    filterOption={(input, option) => {
                                        return (
                                            option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                                        )
                                    }}
                                    onChange={assignId => {
                                        this.setState(
                                            {
                                                assignId: assignId && assignId.toString()
                                            },
                                            () => {
                                                setTimeout(() => {
                                                    this.refreshTasks()
                                                }, 500);
                                            }
                                        );
                                    }}>
                                    {allUsers.map((val, idn) => {
                                        return (
                                            <Option key={idn} value={val._id}>
                                                {val.name}
                                            </Option>
                                        )
                                    })}
                                </Select>
                            </div>
                        </Col>
                        <Col span={6}>
                            Assign By:
                            <br></br>
                            <div style={{ float: 'left', width: '100%' }}>
                                <Select
                                    allowClear
                                    style={{
                                        width: '90%'
                                    }}
                                    filterOption={(input, option) => {
                                        return (
                                            option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                                        )
                                    }}
                                    showSearch={true}
                                    value={this.state.assignById}
                                    placeholder="Select Option"
                                    optionFilterProp="display"
                                    onChange={assignById => {
                                        this.setState(
                                            {
                                                assignById: assignById && assignById.toString()
                                            },
                                            () => {
                                                setTimeout(() => {
                                                    this.refreshTasks()
                                                }, 500);
                                            }
                                        );
                                    }}>
                                    {allUsers.map((val, idn) => {
                                        return (
                                            <Option key={idn} value={val._id}>
                                                {val.name}
                                            </Option>
                                        )
                                    })}
                                </Select>
                            </div>
                        </Col>
                        <Col span={8}>
                            <label>Search By Date</label><br />
                            <RangePicker
                                // defaultValue={[moment(this.state.time.from), moment(this.state.time.to)]}
                                format="YYYY-MM-DD"
                                placeholder={['Start Date', 'End Date']}
                                onChange={this.chooseRangerPicker}
                                onOk={this.onOk}
                            />
                        </Col>
                    </Row>
                    <Row style={{ marginBottom: '1rem', display: 'flex' }}>
                        {/* Filter By Priority */}
                        <Col span={12}>
                            <Row style={{ display: 'flex' }}>
                                <Col span={5} style={{ alignItems: 'center', display: 'flex' }}>
                                    Filter By Priority:
                                </Col>
                                <Col style={{ marginRight: '0.5rem' }}>
                                    <Button onClick={() => {
                                        this.setState({ filterPriority: '' }, () => {
                                            this.refreshTasks()
                                        })
                                    }}>All</Button>
                                </Col>
                                <Col style={{ marginRight: '0.5rem' }}>
                                    <Button style={{ backgroundColor: '#eb354b', color: '#fff', }} onClick={() => {
                                        this.setState({ filterPriority: 'High' }, () => {
                                            this.refreshTasks()
                                        })
                                    }}>High</Button>
                                </Col>
                                <Col style={{ marginRight: '0.5rem' }}>
                                    <Button style={{ backgroundColor: '#50C878', color: '#fff', }} onClick={() => {
                                        this.setState({ filterPriority: 'Normal' }, () => {
                                            this.refreshTasks()
                                        })
                                    }}>Normal</Button>
                                </Col>
                                <Col style={{ marginRight: '0.5rem' }}>
                                    <Button style={{ backgroundColor: '#6495ED', color: '#fff' }} onClick={() => {
                                        this.setState({ filterPriority: 'Low' }, () => {
                                            this.refreshTasks()
                                        })
                                    }}>Low</Button>
                                </Col>
                            </Row>
                        </Col>
                        {/* Filter By Status */}
                        <Col span={12}>
                            <Row style={{ display: 'flex' }}>
                                <Col span={5} style={{ alignItems: 'center', display: 'flex' }}>
                                    Filter By Status:
                                </Col>
                                <Col style={{ marginRight: '0.5rem' }}>
                                    <Button onClick={() => {
                                        this.setState({ filterStatus: '' }, () => {
                                            this.refreshTasks()
                                        })
                                    }}>All</Button>
                                </Col>
                                <Col style={{ marginRight: '0.5rem' }} >
                                    <Button style={{ backgroundColor: '#dc143c', color: '#fff' }} onClick={() => {
                                        this.setState({ filterStatus: 'Pending' }, () => {
                                            this.refreshTasks()
                                        })
                                    }}>Pending</Button>
                                </Col>
                                <Col style={{ marginRight: '0.5rem' }}>
                                    <Button style={{ backgroundColor: '#5C9377', color: '#fff' }} onClick={() => {
                                        this.setState({ filterStatus: 'Complete' }, () => {
                                            this.refreshTasks()
                                        })
                                    }}>Completed</Button>
                                </Col>
                                <Col style={{ marginRight: '0.5rem' }}>
                                    <Button style={{ backgroundColor: '#4169E1', color: '#fff' }} onClick={() => {
                                        this.setState({ filterStatus: 'Forward' }, () => {
                                            this.refreshTasks()
                                        })
                                    }}>Forward</Button>
                                </Col>
                            </Row>
                        </Col>
                    </Row>
                </Card>
                {/* Calender */}
                {/* <Card bordered={true}>
                    <FullCalendar
                        plugins={[
                            dayGridPlugin, 
                            timeGridPlugin, 
                            interactionPlugin
                        ]}
                        headerToolbar={{
                            left: 'prev,next today',
                            center: 'title',
                            right: 'dayGridMonth,timeGridWeek,timeGridDay'
                        }}
                        datesSet={data => {
                            this.getCalendarData(data);
                        }}
                        initialView='dayGridMonth'
                        editable={true}
                        selectable={true}
                        selectMirror={true}
                        dayMaxEvents={true}
                        weekends={this.state.weekendsVisible}
                        forceEventDuration={true}
                        events={allEvents} 
                        eventContent={this.renderEventContent}
                        select={this.handleDateSelect}
                        eventClick={this.handleEventClick}
                        eventsSet={this.handleEvents}
                    />      
                </Card> */}
                <Card bordered={true} style={{ marginTop: 10 }}>
                    <TableComp
                        ref={this.table}
                        columns={columns}
                        apiRequest={this.apiRequest}
                        extraProps={{ scroll: { x: 900 } }}
                        pagination={{
                            showSizeChanger: true,
                            defaultPageSize: 20,
                            pageSizeOptions: ['10', '20', '50', '100', '1000']
                        }}
                    />
                </Card>
            </div>
        )
    }
}

const mapStateToProps = ({ global, router }) => ({
    loading: global.buttonLoading,
    search: router.location.search
})
const mapDispatchToProps = dispatch => {
    return {
        dispatch
    }
}
export default connect(
    mapStateToProps,
    mapDispatchToProps
)(TaskList)
